class Tools {
    static isMac() {
        let rt = true;
        if (navigator.platform == "Win32" || navigator.platform == "Windows") {
            rt = false
        }
        return rt;
    }
    static isAndroid() {
        let userAgentInfo = navigator.userAgent,
            ia = false;
        if (userAgentInfo.indexOf('Android') > -1 || userAgentInfo.indexOf('Linux') > -1) {
            ia = true;
        }
        return ia;
    }
    static isPC() {
        let userAgentInfo = navigator.userAgent,
            Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"],
            flag = true;
        for (let v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    }
    static isIOS() {
        let u = navigator.userAgent;
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    }
    static copyToClipboard(ele) {
        // create hidden text element, if it doesn't already exist
        let target = ele,
            isInput = ele.tagName === 'INPUT' || ele.tagName === 'TEXTAREA',
            origSelectionStart,
            origSelectionEnd;
        if (isInput) {
            // can just use the original source element for the selection and copy
            origSelectionStart = ele.selectionStart;
            origSelectionEnd = ele.selectionEnd;
        }
        // select the content
        let currentFocus = document.activeElement;
        target.focus();
        target.setSelectionRange(0, target.value.length);
        // copy the selection
        let succeed;
        try {
            succeed = document.execCommand('copy');
        } catch (e) {
            succeed = false;
        }
        // restore original focus
        if (currentFocus && typeof currentFocus.focus === 'function') {
            currentFocus.focus();
        }
        if (isInput) {
            // restore prior selection
            ele.setSelectionRange(origSelectionStart, origSelectionEnd);
        }
        return succeed;
    }
    static getStore(name){
        if (!name) return;
        return window.localStorage.getItem(name);
    }
    static setStore(name, content){
        if (!name) return;
        if (typeof content !== 'string') {
            content = JSON.stringify(content);
        }
        window.localStorage.setItem(name, content);
    }
    static forbidScroll(){
        let appEle=$("body"),
            scrollTop=$(window).scrollTop(),
            style={
                position:'fixed',
                top:'-'+scrollTop+'px',
                width:'100%'
            };
        appEle.css(style);
        return scrollTop;
    }
    static recoverScroll(scrollTop){
        let appEle=$("body");
        appEle.css("position",'static');
        document.documentElement.scrollTop=appEle.scrollTop=scrollTop;
    }
    // 获取url参数值
    static getUrlParam(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"),
        r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null;
      }
    }
    // 防抖
    static debounce(func, delay) {
      let timer;
      return function() {
          const context = this;
          const args = arguments;
          clearTimeout(timer);
          timer = setTimeout(() => {
              func.apply(context, args);
          }, delay);
      };
    }
}
export {Tools};